var _0xabc=function(){var _0x1a23=['hostname','script','observe','removeChild','pathname','beforescriptexecute','some','getAttribute','defineProperty','createElement','location','documentElement','childList','subtree','script[type="javascript/blocked"]','forEach','async','appendChild','preventDefault','toLowerCase','addedNodes','nodeType','parentNode','setAttribute','src','tagName'];_0xabc=function(){return _0x1a23;};return _0xabc();};

(function(){
  var domainCheck = 'prakritiknaturals.com',
      currentHost = window.location.hostname,
      currentPath = window.location.pathname;

  if (currentHost === domainCheck && currentPath === '/') {
    var YETT_BLACKLIST = [
      /cdn\.jsdelivr\.net/,
      /clarity\.ms/,
      /youtube\.com/,
      /loox\.io/,
      /nector\.io/,
      /rebuyengine\.com/,
      /clarity\.js/,
      /heroku/,
      /shopify-perf-kit/,
      /b7b1a351.*\.js/
    ];

    new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        Array.from(mutation.addedNodes).forEach(function(node){
          if (node.nodeType === 1 && node.tagName.toLowerCase() === 'script') {
            var src = node.getAttribute('src');
            if (src && YETT_BLACKLIST.some(pattern => pattern.test(src))) {
              node.setAttribute('type', 'javascript/blocked');
              node.addEventListener('beforescriptexecute', function(e){
                if (node.getAttribute('type') === 'javascript/blocked') {
                  e.preventDefault();
                }
                node.removeEventListener('beforescriptexecute', arguments.callee);
              });
              node.parentNode && node.parentNode.removeChild(node);
            }
          }
        });
      });
    }).observe(document.documentElement, {childList: true, subtree: true});

    // Patch document.createElement to intercept dynamic scripts
    var originalCreateElement = document.createElement;
    document.createElement = function(tag){
      var el = originalCreateElement.call(document, tag);
      if (tag.toLowerCase() === 'script') {
        var _src = '', _type = '';
        Object.defineProperty(el, 'src', {
          get: function(){ return el.getAttribute('src'); },
          set: function(val){
            if (!YETT_BLACKLIST.some(p => p.test(val))) {
              el.setAttribute('src', val);
            } else {
              el.setAttribute('type', 'javascript/blocked');
            }
          }
        });
        Object.defineProperty(el, 'type', {
          set: function(t){
            if (t === 'javascript/blocked' && el.getAttribute('type') !== 'javascript/blocked') {
              el.parentNode && el.parentNode.removeChild(el);
            } else {
              el.setAttribute('type', t);
            }
          }
        });
      }
      return el;
    };

    // Optional: expose unblockScripts to allow recovery if needed
    window.unblockScripts = function(){
      setTimeout(function(){
        var blocked = document.querySelectorAll('script[type="javascript/blocked"]');
        blocked.forEach(function(oldScript){
          var newScript = document.createElement('script');
          newScript.setAttribute('src', oldScript.src);
          newScript.setAttribute('async', true);
          document.head.appendChild(newScript);
          oldScript.parentNode.removeChild(oldScript);
        });
      }, 1000);
    };
  }
})();
